module.exports = __webpack_public_path__ + "img/feature-3.be81edaa.png";